import { Navigate, useRoutes } from 'react-router-dom';
import AppLayout from './app/layout';
import DefalutLayout from './app/(default)/layout';
import HomeAppLayout from './app/homeLayout';
import HomePage from './app/(default)/home';
import LoginLayout from './app/(default)/loginLayout';
import { AuthProtectedRoute } from './authRoute';

export default function Router() {

    const routes = useRoutes([
        {
            path: '/',
            element: <AppLayout />,
            children: [
                { element: <DefalutLayout />, index: true },
                {
                    path: '/login',
                    element: <LoginLayout />, index: true
                },
            ]
        },
        {
            path: '/home',
            element: <AuthProtectedRoute> <HomeAppLayout /></AuthProtectedRoute>,
            children: [
                { element: <AuthProtectedRoute> <HomePage /></AuthProtectedRoute>, index: true },

            ]
        },



    ]);
    return routes;
}